import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-[#8B6F47] text-white mt-auto">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About */}
          <div>
            <h3 className="text-xl font-serif font-bold mb-4">Ananya Residency</h3>
            <p className="text-sm text-gray-200 leading-relaxed">
              Comfortable and affordable service apartment in Manipal. 
              Perfect for students, families, hospital visitors and Tourists.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <nav className="flex flex-col space-y-2">
              <Link to="/" className="text-sm text-gray-200 hover:text-white transition-colors">
                Home
              </Link>
              <Link to="/rooms" className="text-sm text-gray-200 hover:text-white transition-colors">
                Room Categories
              </Link>
              <Link to="/gallery" className="text-sm text-gray-200 hover:text-white transition-colors">
                Gallery
              </Link>
              <Link to="/nearby" className="text-sm text-gray-200 hover:text-white transition-colors">
                Nearby Places
              </Link>
              <Link to="/contact" className="text-sm text-gray-200 hover:text-white transition-colors">
                Contact Us
              </Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <div className="flex flex-col space-y-3">
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 flex-shrink-0 mt-1" />
                <span className="text-sm text-gray-200">
                  Aniketh Apartment, Vidyarathna Nagar,<br />
                  V.S Acharya Road, Manipal, Udupi
                </span>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 flex-shrink-0" />
                <a href="tel:+919187501932" className="text-sm text-gray-200 hover:text-white transition-colors">
                  +91 91875 01932
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 flex-shrink-0" />
                <a href="mailto:ananyaresidencymanipal@gmail.com" className="text-sm text-gray-200 hover:text-white transition-colors">
                  ananyaresidencymanipal@gmail.com
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-600 mt-8 pt-8 text-center">
          <p className="text-sm text-gray-200">
            © 2026 Ananya Residency. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
